import React, { useState, forwardRef, useEffect } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TextField } from '@mui/material';
import { Box } from '@mui/system';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const UpdateStock = ({updateDialog, handleClose, row}) => {
  const [actualQty, setActualQty] = useState(0)
  const [diffQty, setDiffQty] = useState(0)
  const [value, setValue] = useState(row ? row.value : 0)
  const [reason, setReason] = useState(row ? row.reason : "Mixing Item Sale")
  useEffect(() => {
    if(row) {
      setActualQty(row.actualQty)
      setDiffQty(row.diffQty)
      setValue(row.value)
    }
  }, [row]);

  useEffect(() => {
    if(row) {
      const diff = actualQty - row.closingQty
      setDiffQty(diff)
      setValue(row.sellingPriceExclTax * diff)
    }
  }, [actualQty, row]);
  
  const updateStock = async() => {
    try {
      row.actualQty = actualQty
      row.diffQty = diffQty
      row.value = value
      row.reason = diffQty !== 0 ? reason : ""
      handleClose();
    } catch (err) {
      console.log(err)
    }
  };

  return (
    <div>
      <Dialog
        open={updateDialog}
        onClose={handleClose}
        TransitionComponent={Transition}
        sx={{width: "100vw"}}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Update Stock
            </Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{margin: "2vh"}}>
          <Grid container spacing={2}>
            <Grid item xs={6}><TextField label="Opening Qty" variant="standard" fullWidth disabled value={row && row.openingQty.toFixed(3)}/></Grid>
            <Grid item xs={6}><TextField label="Inward" variant="standard" fullWidth disabled value={row && row.inward.toFixed(3)}/></Grid>
            <Grid item xs={6}><TextField label="Transfer In" variant="standard" fullWidth disabled value={row && row.transferIn.toFixed(3)}/></Grid>
            <Grid item xs={6}><TextField label="Sales Return" variant="standard" fullWidth disabled value={row && row.salesReturn.toFixed(3)}/></Grid>
            <Grid item xs={6}><TextField label="Transfer Out" variant="standard" fullWidth disabled value={row && row.transferOut.toFixed(3)}/></Grid>
            <Grid item xs={6}><TextField label="Sales" variant="standard" fullWidth disabled value={row && row.sales.toFixed(3)}/></Grid>
            <Grid item xs={6}><TextField label="Closing Qty" variant="standard" fullWidth disabled value={row && row.closingQty.toFixed(3)}/></Grid>
            <Grid item xs={6}><TextField label="Actual Qty" variant="standard" fullWidth type="number" value={actualQty} onChange={(event) => setActualQty(event.target.value)}/></Grid>
            <Grid item xs={4}><TextField label="Diff Qty" variant="standard" fullWidth disabled value={diffQty.toFixed(3)}/></Grid>
            <Grid item xs={4}><TextField label="SP Excl Tax" variant="standard" fullWidth disabled value={row && row.sellingPriceExclTax.toFixed(3)}/></Grid>
            <Grid item xs={4}><TextField label="Value" variant="standard" fullWidth disabled value={value.toFixed(2)}/></Grid>
            {diffQty !== 0 &&< Grid item xs={12}>
              <TextField select value={reason} label="Reason" onChange={(event)=> setReason(event.target.value)} variant="standard" SelectProps={{native: true}} fullWidth>
                { diffQty > 0 ? (<>
                  <option key="Incorrect Billing" value="Incorrect Billing">Incorrect Billing</option>
                  <option key="Mixing Item Sale" value="Mixing Item Sale">Mixing Item Sale</option>
                </>
                ) : (<>
                  <option key="Without Bill Sale" value="Without Bill Sale">Without Bill Sale</option>
                  <option key="Sample Sale" value="Sample Sale">Sample Sale</option>
                  <option key="Wastage" value="Wastage">Wastage</option>
                  <option key="Billing Qty Error" value="Billing Qty Error">Billing Qty Error</option>
                  <option key="Billing ItemCode Error" value="Billing ItemCode Error">Billing ItemCode Error</option>
                  <option key="Mixing Item Sale" value="Mixing Item Sale">Mixing Item Sale</option>
                </>)
                }
                
              </TextField>
            </Grid>}
            <Grid item xs={12}>
              <Button autoFocus variant="contained" onClick={updateStock} fullWidth>
              Update
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    </div>
  )
}

export default UpdateStock
